import { ReactComponent as Logo } from '../../assets/icons/profile.svg'

const Person = () => {
    return <Logo width={20} height={20} fill='white' />
}

export default Person
